import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IncomingHttpHeaders } from 'node:http';
import type { AxiosError } from 'axios';
import { JobListRecommendationsInterestsResponse } from '@doda/api-client/aspida/@types/index';
import { apiClient } from '@doda/api-client/util/apiClient';

export interface RejectedValue {
  message: string;
  redirect: boolean;
}

export const getInterestsJobList = createAsyncThunk<
  JobListRecommendationsInterestsResponse,
  {
    headers: IncomingHttpHeaders;
  },
  {
    rejectValue: RejectedValue;
  }
>('interestsJobList/getInterestsJobList', async ({ headers }, thunkAPI) => {
  try {
    const jobList = await apiClient.api.v1.jobs.recommendations.interests.$get({
      config: { headers },
    });
    return jobList;
  } catch (error) {
    const axiosError = error as AxiosError;
    return thunkAPI.rejectWithValue({
      message: `message: ${axiosError.message} path: ${decodeURI(
        axiosError.request?.path
      )}`,
      redirect: false,
    });
  }
});
